import classNames from 'classnames';
import React from 'react';

function getRandomKey() {
	return Math.random().toString(36)
		.slice(-6);
}

export interface CodeDiffCardProps {
	diff: Diff.Change[];
	type: 'new' | 'old';
}

export const CodeDiffCard: React.FC<CodeDiffCardProps> = ({ diff, type }) => {
	const isNewCode = type === 'new';

	return (
		<div className='code'>
			{ diff.map((part) => {
				const { added, removed, value } = part;
				const className = classNames('diff-text', {
					addedFromOld: !isNewCode && added,
					addedToNew: isNewCode && added,
					removedFromNew: isNewCode && removed,
					removedFromOld: !isNewCode && removed
				});

				return (
					<span
						className={ className }
						key={ getRandomKey() }>
						{ value }
					</span>
				);
			}) }
		</div>
	);
};
